import { render, staticRenderFns } from "./AscRelatedMxRecsGrid.vue?vue&type=template&id=22d23f8b&scoped=true&"
import script from "./AscRelatedMxRecsGrid.vue?vue&type=script&lang=js&"
export * from "./AscRelatedMxRecsGrid.vue?vue&type=script&lang=js&"
import style0 from "./AscRelatedMxRecsGrid.vue?vue&type=style&index=0&id=22d23f8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d23f8b",
  null
  
)

export default component.exports